import React from 'react'
import { Link } from 'react-router-dom';
import Details_01 from '../../../assets/images/portfolio/protfolio-details-9.jpg';
import Details_02 from '../../../assets/images/portfolio/protfolio-details-10.jpg';
import Details_03 from '../../../assets/images/portfolio/protfolio-details-11.jpg';
import Details_04 from '../../../assets/images/portfolio/protfolio-details-12.jpg';
import Details_05 from '../../../assets/images/portfolio/protfolio-details-13.jpg';
import Port_Insta from '../../../assets/images/svg/header/Insta.svg';
import Port_fb from '../../../assets/images/svg/header/Fb.svg';
import Port_Twiter from '../../../assets/images/svg/header/Twiter.svg';
import Port_Pinterest from '../../../assets/images/svg/header/Pintrest.svg';




const Details = () => {
    return (
        <>
            <div className="portfolio-details-section">
                <div className="container">
                    <div className="row gutter-y-40">
                        <div className="col-lg-8">
                            <div
                                className="portfolio-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="portfolio-list-image">
                                    <img
                                        src={Details_01}
                                        alt="portfolio-image"
                                    />
                                </div>
                            </div>
                            <div
                                className="portfolio-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="300ms"
                            >
                                <h4>Bank Credit Collection System</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.{" "}
                                </p>
                                <p>
                                    Duis aute irure dolor in reprehenderit in voluptate velit esse
                                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                                    cupidatat non proident, sunt in culpa qui officia deserunt mollit
                                    anim id est laborum. Sed ut perspiciatis unde omnis iste natus error
                                    sit voluptatem accusantium doloremque laudantium, totam rem aperiam,
                                    eaque ipsa quae ab illo inventore veritatis et quasi architecto
                                    beatae vitae dicta sunt explicabo.
                                </p>
                                <div className="portfolio-details-image">
                                    <div className="portfolio-image">
                                        <img
                                            src={Details_02}
                                            alt="portfolio-image"
                                        />
                                    </div>
                                    <div className="portfolio-image">
                                        <img
                                            src={Details_03}
                                            alt="portfolio-image"
                                        />
                                    </div>
                                </div>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur.
                                </p>
                            </div>
                            <div
                                className="portfolio-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <h4>Management Style</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur. Excepteur sint occaecat cupidatat non proident.
                                </p>
                                <ul className="portfolio-list">
                                    <li>
                                        <span>+</span>Business Insurance
                                    </li>
                                    <li>
                                        <span>+</span>Marketing Analyses{" "}
                                    </li>
                                </ul>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.{" "}
                                </p>
                            </div>
                            <div
                                className="portfolio-pagination animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="500ms"
                            >
                                <div className="portfolio-pagination-inner">
                                    <Link to="#">
                                        <img
                                            src={Details_04}
                                            alt="portfolio-image"
                                        />
                                    </Link>
                                    <Link to="#" className="portfolio-pagination-title">
                                        <i className="fa-solid fa-chevron-left" />
                                        <span>Prev Project</span>
                                    </Link>
                                </div>
                                <div className="portfolio-pagination-inner next">
                                    <Link to="#" className="portfolio-pagination-title">
                                        <span>Next Project</span>
                                        <i className="fa-solid fa-chevron-right" />
                                    </Link>
                                    <Link to="#">
                                        <img
                                            src={Details_05}
                                            alt="portfolio-image"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div >
                        <div className="col-lg-4">
                            <div className="portfolio-sidebar">
                                <div
                                    className="portfolio-widget animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <h4>Case Information</h4>
                                    <ul>
                                        <li>
                                            <p>Date:</p> <span>September 15, 2024</span>
                                        </li>
                                        <li>
                                            <p>Client:</p> <span>John david</span>
                                        </li>
                                        <li>
                                            <p>Timeline:</p> <span>2024 - 2024</span>
                                        </li>
                                        <li>
                                            <p>Service:</p> <span>Market Reporting</span>
                                        </li>
                                    </ul>
                                    <ul className="portfolio-details-social-media">
                                        <li>
                                            <Link to="https://www.instagram.com/">
                                                <img src={Port_Insta} alt="icon" />
                                                <span>Instagram</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.facebook.com/">
                                                <img src={Port_fb} alt="icon" />
                                                <span>Facebook</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://x.com/">
                                                <img src={Port_Twiter} alt="icon" />
                                                <span>Twiter</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.pinterest.com/">
                                                <img src={Port_Pinterest} alt="icon" />
                                                <span>Pintrest</span>
                                            </Link>
                                        </li>
                                    </ul >
                                </div >
                            </div >
                        </div >
                    </div >
                </div >
            </div >

        </>
    )
}

export default Details
